/**
 * @about don't mistake with simple dash, some editors might display dash and em-dash the same
 * @returns EM-DASH
 */
export const EMPTY_PLACEHOLDER = '—';
